<app-tab-group *ngIf="!isLoading">
  <app-tab
    *ngFor="let element of tabData; let i = index"
    label="{{ element.label }}"
    flagColor="{{ isMvpValidData ? element.color : 'gray' }}"
  >
    <table>
      <tr>
        <th>Risk Activity</th>
        <th>Risk Status</th>
        <th>Description Activities</th>
      </tr>
      <tr *ngFor="let flag of riskFlags; let i = index">
        <td>
          <a
            routerLink="/details/{{ data.therapeuticArea.id }}/{{
              elementName
            }}/{{ element.label }}_{{ flag.link }}"
            *ngIf="i == 0 && isMvpValidData && element.label === 'ABAC'"
          >
            {{ flag.name }}
          </a>
          <span *ngIf="i != 0 || !isMvpValidData || element.label !== 'ABAC'">{{
            flag.name
          }}</span>
        </td>
        <td>
          <ng-container
            *ngTemplateOutlet="
              progressBarTemplate;
              context: { info: element.progressBars[i] }
            "
          ></ng-container>
        </td>
        <td>
          {{ getDescriptionForFlag(flag, element.label) }}
        </td>
      </tr>
    </table>
  </app-tab>
</app-tab-group>

<ng-template #progressBarTemplate let-info="info">
  <div class="progress-bar-container">
    <div
      *ngFor="let numb of info; let i = index"
      class="progress-bar {{ numb.color }}"
      [ngStyle]="{ 'width.px': numb.value * (isLoading ? 0 : 3) }"
      [matTooltip]="numb.value < 10 ? numb.value + '%' : ''"
      [class.clickable]="numb.value < 10"
    >
      <span
        *ngIf="!isLoading && numb.value >= 10 && numb.value < 100"
        [class.dominant]="numb.isDominant"
      >
        {{ numb.value }}%
      </span>
    </div>
  </div>
</ng-template>
